<div class="header">
  <dk-progress-bar [progressValues]="progressValues"></dk-progress-bar>
  <span class="title-text">{{ 'doktar_app.auth.register.profession.title' | translate }}</span>
  <span class="subtitle-text">
    {{ 'doktar_app.auth.register.profession.subtitle' | translate }}
  </span>
</div>

<div class="professions-container">
  @for (option of options; track option) {
    <div class="profession-row">
      <dk-button
        [outlined]="true"
        severity="secondary"
        [ngClass]="selectedOption == option ? 'selected-profession-button' : 'profession-button'"
        (onClick)="addOrRemoveProfession(option)">
        <div class="profession-card">
          <div class="profession-card-icon">
            <i
              class="{{ option.icon | splitString }} {{
                selectedOption == option ? 'selected-profession-card-icon' : ''
              }}"></i>
          </div>
          <div class="profession-card-label">
            {{ (option.value ? option.value : '') | translate }}
          </div>
        </div>
      </dk-button>
    </div>
  }
</div>
<div class="profession-buttons">
  @if (somethingWentWrong) {
    <div class="error-container">
      <span class="error-text">
        {{ errorMessage | translate }}
      </span>
    </div>
  }
  <dk-button
    [outlined]="true"
    severity="primary"
    class="continue-button"
    [size]="'xlarge'"
    [label]="'doktar_app.common.continue' | translate"
    [disabled]="selectedOption == undefined"
    [loading]="submitting"
    (onClick)="continueProfessionStep()"></dk-button>
  <dk-button
    class="skip-this-step-button"
    (onClick)="skipProfession()"
    severity="contrast"
    [text]="true"
    [outlined]="false"
    [size]="'xlarge'"
    [disabled]="submitting"
    [label]="'doktar_app.common.skip_this_step' | translate">
  </dk-button>
</div>
